<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AMj3c1/tc-custom/9781617456183.jpg?1725275783926" alt="This image is the cover for the book Sweet & Simple Wool Appliqué"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sweet & Simple Wool Appliqué
      </h1>
      <p class="bookDescription body article font2">
        <b>Master the art of wool appliqué with this step-by-step guide featuring a range of projects by some of today’s top designers.</b><br/><br/>From traditional pincushions to playful embellishments on a contemporary blue jean jacket, this delightful book offers something for everyone. The 16 featured projects present a full range of challenges for all skill levels, whether you want to try wool appliqué for the first time or you’re an experienced wool fanatic. <br/><br/>Projects include everything from a table runner, a pillow, and pinkeeps to a needle book, a notebook cover, a wallhanging-sized quilt, and more. Contributing designers include Lori Brechlin, Annie Downs, Stacy Nash, Marlene Strauser, and more.<br/><br/><b>This eBook edition includes links to printable appliqué patterns.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        C&T Publishing
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing, Inc
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?243e27f9